// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607300504/js/" + chunkId + "." + {"44":"86e90066","225":"8b0a8952","481":"b8bb69fe","486":"d9215a1b","770":"fcef964c"}[chunkId] + ".0.10203316885732672.chunk.js";
};